(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-dr-config]').textContent);
    const form = root.querySelector('#dr-form');
    const submitButtons = [...form.querySelectorAll('[type=submit]')];
    const tiers = [...root.querySelectorAll('[data-offer-glasses]')];
    const error = root.querySelector('.ar-error');
    const money = cents => new Intl.NumberFormat('de-DE', {style: 'currency', currency: root.dataset.currency || 'EUR'}).format(cents / 100);
    let glasses = config.initialGlasses || 3;
    let adding = false;
    const notice = root.querySelector('[data-mode-notice]');
    const isSubscription = () => form.querySelector('[name=purchase_mode]:checked').value === 'subscription';
    const getSelection = () => {
      const tier = tiers.find(el => Number(el.dataset.offerGlasses) === glasses);
      const subscription = isSubscription();
      const plan = Number(tier?.dataset.tierPlan);
      const price = Number(subscription ? tier?.dataset.tierPrice : tier?.dataset.tierOncePrice);
      return {subscription, id:Number(tier?.dataset.tierVariant), plan, quantity:1, glasses,
        price, months:glasses, unitPrice:price/glasses,
        available:!!tier && (subscription ? glasses!==6 : glasses!==2) && tier.dataset.tierAvailable === 'true' && price>0 && (!subscription || plan>0)};
    };
    function update() {
      const state = getSelection();
      form.elements.id.value = state.id;
      form.elements.quantity.value = state.quantity;
      form.elements.selling_plan.disabled = !state.subscription;
      form.elements.selling_plan.value = state.subscription ? state.plan : '';
      tiers.forEach(el => {
        const n = Number(el.dataset.offerGlasses);
        const hasPlan = Number(el.dataset.tierPlan)>0;
        el.hidden = state.subscription ? n===6 : n===2;
        const sub = state.subscription && hasPlan;
        const price = Number(sub ? el.dataset.tierPrice : el.dataset.tierOncePrice);
        el.setAttribute('aria-pressed',String(n === glasses));
        el.querySelector('[data-tier-unit]').textContent = `${money(price/n)} je Glas`;
        el.querySelector('[data-tier-total]').textContent = `${money(price)} ${sub ? 'pro Lieferung' : 'einmalig'}`;
        el.querySelector('[data-tier-note]').textContent = sub ? 'Gua Sha + 2 E-Books' : '2 E-Books inklusive';
        if(n===6) el.querySelector('[data-tier-note]').textContent += ' + Routinentracker';
        if(n===6) el.querySelector('.ar-tier-badge').textContent = 'Bester Glaspreis';
      });
      root.querySelector('[data-total-price]').textContent = money(state.price);
      const interval = state.months === 1 ? 'monatlich' : `alle ${state.months} Monate`;
      root.querySelector('[data-price-period]').textContent = state.subscription ? 'PRO LIEFERUNG' : 'EINMALIG';
      root.querySelector('[data-unit-price]').textContent = `${money(state.unitPrice)} je Glas`;
      root.querySelector('[data-cta-label]').textContent = state.available ? 'In den Warenkorb legen' : 'Aktuell nicht verfügbar';
      submitButtons.forEach(button => button.disabled = adding || !state.available);
      root.querySelector('[data-cadence]').textContent = `${state.glasses} ${state.glasses === 1 ? 'Glas' : 'Gläser'} · ${state.glasses*30} Tagesportionen`;
      root.querySelector('[data-supply]').textContent = `${state.glasses*60} Kapseln · ${state.glasses*30} Tagesportionen`;
      root.querySelector('[data-frequency]').textContent = state.subscription ? (state.months === 1 ? 'Monatlicher Nachschub' : `Nachschub alle ${state.months} Monate`) : 'Einmalige Lieferung';
      root.querySelector('[data-flex]').textContent = state.subscription ? 'Jederzeit überspringen oder kündigen' : 'Keine Abo-Bindung';
      const renewal = root.querySelector('[data-renewal]');
      renewal.textContent = state.subscription ? `${money(state.price)} pro Lieferung für ${state.glasses} ${state.glasses === 1 ? 'Glas' : 'Gläser'}, Lieferung und Abrechnung ${interval}. Automatische Verlängerung. Jederzeit überspringen oder kündigen.` : 'Einmalige Bestellung. Keine automatische Verlängerung und keine Folgelieferungen.';
      root.querySelector('[data-selection-note]').textContent = state.subscription ? `${money(state.price)} pro Lieferung · ${interval} im Abo.` : `${money(state.price)} einmalig.`;
      root.querySelector('[data-sticky-price]').textContent = `${money(state.price)} ${state.subscription ? `· ${interval} im Abo` : '· einmalig'}`;
      root.querySelector('[data-six-tracker]').hidden = state.glasses !== 6;
      const guaIncluded = state.subscription;
      root.querySelector('[data-gua-bonus]').hidden = !guaIncluded;
      root.querySelector('.ar-gifts').classList.toggle('ar-gifts--once',!state.subscription);
      root.querySelector('[data-gua-caption]').textContent = 'Gratis bei deiner ersten Abo-Bestellung';
      root.querySelector('[data-bonus-access]').textContent = `Beide E-Books gratis als Kaufbonus. Zugang nach dem Kauf. ${state.glasses===6 ? 'Foto-Tagebuch und zusätzlicher 6-Monats-Routinentracker zum Ausdrucken weiter unten.' : 'Das Foto-Tagebuch findest du weiter unten.'}`;
      root.querySelector('[data-extras-heading]').textContent = config.bonusValuesVerified ? `${money((Number(config.guideValue)+Number(config.resetValue)+(guaIncluded ? Number(config.guaValue) : 0))*100)} Extras gratis` : 'Deine kostenlosen Extras';
      const guaValue = root.querySelector('[data-gua-value]');
      if(guaValue) { guaValue.hidden = !guaIncluded; guaValue.textContent = `Einzelpreis ${config.guaValue} € · gratis`; }
    }
    form.addEventListener('change', e => {
      notice.textContent = '';
      if(e.target.name==='purchase_mode' && ((isSubscription() && glasses===6) || (!isSubscription() && glasses===2))) {
        glasses = 3;
        notice.textContent = 'Der 3-Monats-Vorrat ist ausgewählt.';
      }
      update();
    });
    tiers.forEach(el => el.addEventListener('click', () => {
      if(el.hidden) return;
      glasses = Number(el.dataset.offerGlasses);
      notice.textContent = '';
      update();
    }));
    root.querySelectorAll('[data-choose-sub]').forEach(el => el.addEventListener('click', () => {
      form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth',block:'start'});
      form.querySelector('[name=purchase_mode]:checked').focus({preventScroll:true});
    }));
    root.querySelector('[data-print-diary]').addEventListener('click', () => {
      document.querySelector('#dr-diary-print-copy')?.remove();
      const printCopy = document.createElement('section');
      printCopy.id = 'dr-diary-print-copy';
      printCopy.className = 'ar';
      printCopy.append(root.querySelector('#dr-photo-diary').cloneNode(true));
      document.body.append(printCopy);
      document.body.classList.add('dr-print-diary');
      window.print();
    });
    window.addEventListener('afterprint', () => {
      document.body.classList.remove('dr-print-diary');
      document.querySelector('#dr-diary-print-copy')?.remove();
    });
    let galleryIndex = 0;
    const galleryButtons = [...root.querySelectorAll('[data-gallery]')];
    function showSlide(index) {
      galleryIndex=(index+galleryButtons.length)%galleryButtons.length;
      galleryButtons.forEach((el,i)=>el.setAttribute('aria-pressed',String(i===galleryIndex)));
      root.querySelectorAll('[data-slide]').forEach(el=>el.hidden=Number(el.dataset.slide)!==galleryIndex);
    }
    galleryButtons.forEach((el,i)=>el.addEventListener('click',()=>showSlide(i)));
    root.querySelector('[data-gallery-prev]').addEventListener('click',()=>showSlide(galleryIndex-1));
    root.querySelector('[data-gallery-next]').addEventListener('click',()=>showSlide(galleryIndex+1));
    const stage=root.querySelector('.ar-gallery-stage'); let touch=null;
    stage.addEventListener('touchstart',e=>{touch={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}}, {passive:true});
    stage.addEventListener('touchend',e=>{if(!touch)return;const dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)showSlide(galleryIndex+(dx<0?1:-1));touch=null},{passive:true});
    root.querySelectorAll('.ar-accordion').forEach(group=>group.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)group.querySelectorAll('details').forEach(other=>{if(other!==detail)other.open=false})})));
    async function addToCart(state, button, errorTarget) {
      if (adding || !state.available) return;
      adding = true;
      const controls = [...submitButtons, ...root.querySelectorAll('[data-bundle]')];
      const disabledBefore = controls.map(control => control.disabled);
      controls.forEach(control => control.disabled = true);
      errorTarget.hidden = true;
      const label = button.querySelector('[data-cta-label]') || button;
      const previousLabel = label.textContent;
      label.textContent = 'Wird hinzugefügt …';
      let navigating = false;
      try {
        const guaIncluded = state.subscription;
        const item={id:state.id,quantity:state.quantity,properties:{'Gratis-Extras':`Routinen-Guide, Skin Reset, Foto-Tagebuch${guaIncluded ? ', Gua Sha Stein' : ''}${state.glasses===6 ? ', 6-Monats-Routinentracker' : ''}`}};if(state.subscription)item.selling_plan=state.plan;
        // This form supplies Seal plans explicitly; skip Appstle's plan-rewriting interceptor.
        const response=await fetch(root.dataset.addUrl+'?appstle=true',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Bitte versuche es erneut.');
        window.location.assign(root.dataset.cartUrl);
        navigating = true;
        label.textContent = 'Zum Warenkorb …';
      } catch(err){errorTarget.textContent=err.message||'Es gab ein Verbindungsproblem. Bitte versuche es erneut.';errorTarget.hidden=false}
      finally {
        if (!navigating) {
          adding = false;
          label.textContent = previousLabel;
          controls.forEach((control,index) => control.disabled = disabledBefore[index]);
          update();
        }
      }
    }
    form.addEventListener('submit', e => {
      e.preventDefault();
      addToCart(getSelection(), e.submitter || submitButtons[0], error);
    });
    const sticky=root.querySelector('.ar-sticky');
    if('IntersectionObserver'in window)new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0}).observe(submitButtons[0]);
    update();
    initReviews(root);
  }
  function initReviews(root) {
    const reviewRoot=root.querySelector('#dr-reviews');if(!reviewRoot)return;
    const list=reviewRoot.querySelector('#drvL');
    const items=[...list.querySelectorAll('.drv-i')];
    const search=reviewRoot.querySelector('.drv-si input');
    const sort=reviewRoot.querySelector('.drv-so');
    const pager=reviewRoot.querySelector('#drvPg');
    const topics=[...reviewRoot.querySelectorAll('.drv-pl button')];
    const status=document.createElement('p');status.className='drv-status';status.setAttribute('aria-live','polite');list.before(status);
    search.setAttribute('aria-label','Kundenbewertungen durchsuchen');sort.setAttribute('aria-label','Kundenbewertungen sortieren');
    let page=1,topic='all';const size=10;
    const numberDate=el=>{const [d,m,y]=el.querySelector('.drv-dt').textContent.trim().split('.');return Number(y+m+d)};
    const rating=el=>[...el.querySelector('.drv-st').textContent].filter(x=>x==='★').length;
    function render(scroll=false){
      const term=search.value.trim().toLocaleLowerCase('de');
      let filtered=items.filter(el=>(topic==='all'||el.dataset.t.split(' ').includes(topic))&&el.textContent.toLocaleLowerCase('de').includes(term));
      filtered.sort(sort.selectedIndex===1?(a,b)=>parseInt(b.querySelector('.drv-hu').textContent)-parseInt(a.querySelector('.drv-hu').textContent):sort.selectedIndex===2?(a,b)=>rating(b)-rating(a): (a,b)=>numberDate(b)-numberDate(a));
      const totalPages=Math.max(1,Math.ceil(filtered.length/size));page=Math.min(page,totalPages);
      items.forEach(el=>el.hidden=true);filtered.forEach((el,i)=>{list.append(el);el.hidden=i<(page-1)*size||i>=page*size});
      status.textContent=filtered.length?`${filtered.length} angezeigte Bewertungen · Seite ${page} von ${totalPages}`:'Keine Bewertungen zu dieser Suche gefunden.';
      pager.replaceChildren();
      for(let i=1;i<=totalPages;i++){const b=document.createElement('button');b.type='button';b.className='drv-pg'+(i===page?' a':'');b.textContent=i;b.setAttribute('aria-label',`Bewertungsseite ${i}`);if(i===page)b.setAttribute('aria-current','page');b.addEventListener('click',()=>{page=i;render(true)});pager.append(b)}
      if(scroll)list.scrollIntoView({behavior:'smooth',block:'start'});
    }
    topics.forEach(el=>{const source=el.getAttribute('data-old-filter')||'';const match=source.match(/,'([^']+)'/);el.type='button';el.addEventListener('click',()=>{topic=match?match[1]:'all';page=1;topics.forEach(b=>b.classList.toggle('a',b===el));render()})});
    search.addEventListener('input',()=>{page=1;render()});sort.addEventListener('change',()=>{page=1;render()});
    // Vote counts are existing shop data; don't fabricate new votes without a backend.
    reviewRoot.querySelectorAll('.drv-hb').forEach(el=>{el.disabled=true;el.title='Bisherige Stimmen';});
    render();
  }
  init(document.querySelector('#dr-product'));
  document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('#dr-product')));
})();
